import { useDispatch, useSelector } from "react-redux";
import { setGlobalTagsRedux, setSelectedTagPageRedux, setTagsLoadingRedux } from "../../Store/slices/tagSlice";
import ListTags from "../../Pages/Tags/components/ListTags";
import AddTags from "../../Pages/Tags/components/AddTags";
import axios from "axios";
import { useState } from "react";
import UpdateTags from "../../Pages/Tags/components/UpdateTags";
import DeleteTags from "../../Pages/Tags/components/DeleteTags";
import toast from "react-hot-toast";

export const useTagsHook = () => {
    const dispatch = useDispatch();
    const { selectedTagPage, tagsLoading } = useSelector((state: any) => state.tags.value);
    const { accessToken } = useSelector((state: any) => state.auth.value);
    const [tags, setTags] = useState<any>(null);
    const [tagTitleToAdd, setTagTitleToAdd] = useState('');
    const [tagTitleToUpdate, setTagTitleToUpdate] = useState('');
    const [selectedTagId, setSelectedTagId] = useState('');
    const [selectedTagName, setSelectedTagName] = useState('');

    const BASE_URL = 'https://api.eatwellmama.com';

    const setSelectedTagPage = (page: number) => {
        dispatch(setSelectedTagPageRedux(page));
    };

    const returnSelectedTagPage = () => {
        switch (selectedTagPage) {
            case 1: return <ListTags />;
            case 2: return <AddTags />;
            case 3: return <UpdateTags />;
            case 4: return <DeleteTags />;
            default: return <ListTags />;
        }
    };

    const fetchTags = async () => {
        await axios.get(BASE_URL + '/api/tags/fetchAllTags')
            .then((res) => {
                setTags(res.data);
                dispatch(setGlobalTagsRedux(res.data.data));
                dispatch(setTagsLoadingRedux(false));
                console.log(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const addNewTag = async () => {
        dispatch(setTagsLoadingRedux(true));
        await axios.post(
            BASE_URL + '/api/tags/createTag',
            {
                tagTitle: tagTitleToAdd,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then(async (res) => {
            console.log(res.data);
            toast.success('Tag added successfully!');
            await fetchTags();
        }).catch((err) => {
            console.log(err);
            toast.error('Error occurred while adding tag!');
        });
    };

    const deleteTag = async (tagName: string) => {
        dispatch(setTagsLoadingRedux(true));
        await axios.delete(
            BASE_URL + '/api/tags/deleteTag',
            {
                data: { tagName: tagName },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then(async (res) => {
            console.log(res.data);
            toast.success('Tag deleted successfully!');
            await fetchTags();
        }).catch((err) => {
            console.log(err);
            toast.error('Error occurred while deleting tag!');
        });
    };

    const updateTag = async (oldTagName: string, newTagName: string) => {
        dispatch(setTagsLoadingRedux(true));
        await axios.put(
            BASE_URL + '/api/tags/updateTag',
            {
                tagName: oldTagName,
                newTagName: newTagName,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then(async (res) => {
            console.log(res.data);
            toast.success('Tag updated successfully!');
            await fetchTags();
        }).catch((err) => {
            console.log(err);
            toast.error('Error occurred while updating tag!');
        });
    };

    return {
        selectedTagPage,
        setSelectedTagPage,
        tagsLoading,
        returnSelectedTagPage,
        addNewTag,
        deleteTag,
        updateTag,
        tagTitleToAdd,
        setTagTitleToAdd,
        tagTitleToUpdate,
        setTagTitleToUpdate,
        selectedTagId,
        setSelectedTagId,
        selectedTagName,
        setSelectedTagName,
        fetchTags,
        tags,
    };
};